import { Shipment } from '@cemex-core/cmx-api/models/calendars/calendar';
import { UNITS } from '@ordersnproducts/modules/shared/constants/units';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';

/**
 * Validate data of travel time and distance(from shipment) to be greater than 0.
 * @param shipment data to validate
 * @returns true if travelTime and distance are greater than 0, false otherwise.
 */
export const validateTravelTimeData = (shipment: Shipment) => {
  return _safe(() => shipment.travelTime, 0) > 0 && _safe(() => shipment.distance, 0) > 0;
};

/**
 * Extract the numeric value of LoadSize
 *
 * @param object LoadSize
 */
export function getLoadSizeValue(loadSize: string) {
  const loadSizeCode = _safe(() => loadSize, '');
  const cubicYard = UNITS.CUBIC_YARD.trim().toLowerCase();
  const tmp = loadSizeCode.toLowerCase().replace(cubicYard, '');
  return Number(tmp);
}
